import { NavLink } from "react-router-dom";
import { paths } from "../../utils/paths";
import "./SideBar.scss";
import Offcanvas from "react-bootstrap/Offcanvas";
import { images } from "../../utils/images";
import { MdClose } from "react-icons/md";
import { mainContext } from "../../utils/WebContext";
import { Fragment, useContext } from "react";

const SideBar = ({ menu, setMenu }) => {
  const { headerService, involvedService } = useContext(mainContext);
  return (
    <Offcanvas className="side_bar" show={menu} onHide={() => setMenu(false)}>
      <Offcanvas.Header>
        <Offcanvas.Title>
          <img src={images.logoWhite} alt="Brand Logo" />
          <button type="button" onClick={() => setMenu(false)}>
            <MdClose />
          </button>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="link_col">
          <NavLink to={paths.HOME} onClick={() => setMenu(false)}>Home</NavLink>
          <NavLink to={paths.ABOUT} onClick={() => setMenu(false)}>About Us</NavLink>
          <NavLink to={paths.SERVICES} onClick={() => setMenu(false)}>Services</NavLink>
          <NavLink to={paths.BLOGS} onClick={() => setMenu(false)}>News & Events</NavLink>
          {headerService?.map((data) => {
            return (
              <Fragment key={data?._id}>
                <NavLink to={`/info/${data?.slug}`} onClick={() => setMenu(false)}>{data?.name}</NavLink>
              </Fragment>
            );
          })}
          {involvedService?.length > 0 && (
            <NavLink to={`/get-involved/${involvedService?.[0]?.slug}`} onClick={() => setMenu(false)}>
              Get Involved
            </NavLink>
          )}
          <NavLink to={paths.CONTACT}>Contact</NavLink>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default SideBar;
